
function initialState () {
  return {
    completed: false
  }
}

// initial state
const state = initialState()

// mutations
const mutations = {
  reset (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  completed (state, value) {
    state.completed = value
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/progress.js